import React, { useState } from 'react';
import { EditLegalDocument } from './editLegalDocument';
import { SearchLegalDocument } from './searchLegalDocuments';

export function AdminLegalDocuments() {
	const [showEdit, setShowEdit] = useState(false);
	const [selectedLegalDocument, setSelectedLegalDocument] = useState();
	const [refresh, setRefresh] = useState(0);

	const handleOnSelected = (legalDoc) => {
		setShowEdit(true);
		setSelectedLegalDocument({ legalDocumentId: legalDoc.legalDocumentId, legalDocumentType: legalDoc.legalDocumentType, file: legalDoc.file });
	};
	const handleOnNew = () => {
		setSelectedLegalDocument(null);
		setShowEdit(true);
	};
	const handleOnCancelEdit = () => {
		setSelectedLegalDocument(null);
		setShowEdit(false);
	}
	const handleOnSaveEdit = () => {
		setRefresh(prev => prev + 1);
		setShowEdit(false);
	}
	return (
		<div>
			<div className="mb-4 mt-4 divtop ">
				<div className="box_ttl_opt no_reverse">
					<h3 className="mb-0">Lista de documentos legales</h3>
					<div className="box_actions ">
						<button type="button" className="btn secundary mr-2" onClick={handleOnNew}><i className="fas fa-plus"></i> Agregar documento</button>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-12">
					{showEdit ?
						<EditLegalDocument currentLegalDocument={selectedLegalDocument} onCancelEdit={handleOnCancelEdit} onSave={handleOnSaveEdit} />
						: null}
				</div>
			</div>

			<SearchLegalDocument onSelectLegalDocument={handleOnSelected} refresh={refresh} />
		
		</div>
	);
}